import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';

import { AuthTokenService } from './auth-token.service';
import { CommonRequestService } from './common-request.service';
import { AppSettings } from './../app.settings';
import { UserSubscription } from './admin.service';
import { IntegratorClient } from './integrator.service';
import { NguidPattern } from './agency-info.service';
import { environment } from 'environments/environment';

export interface UserInfo {
	customerId: number;
	customerName: string;
	customerEmail: string;
	parentCustomerId?: number;
	userId: number;
	userName: string;
	userEmail: string;
	isAdmin: boolean;
	isSuperAdmin?: boolean;
	subscriptionId?: number;
	userSubId?: number;
}
export interface CustomerInfo {
	id: number;
	nameShort: string;
	nameLong: string;
	type: CustomerType;
	adminEmails: string[];
	parentId: number;
	children: SubAgency[]; // Child agencies
	parentEmails?: string[];
	parentName?: string;
	level: number;
	givState: string; // The state the customer belongs to
	cusCounties: string[];
	neighborCounties: string[];
	cusCentroid: string;
	discrepancyId;
	bdryCate: string;
	bdryName: string
	nguidPattern: NguidPattern;
}
export interface SubAgency {
	id: number;
	name: string;
	adminEmails: string[];
}
export type CustomerType = 'integrator' | 'end-user';

export interface SelectedCustomer {
	nameShort: string;
	id: number;
	adminEmails: string[];
}

@Injectable()
export class UserService {

	public customerInfo: CustomerInfo;
	public userSubscription: UserSubscription;
	// For integrators
	public clients: IntegratorClient[];

	// public selectedCustomerId: BehaviorSubject<number> = new BehaviorSubject(null);
	public selectedCustomer: BehaviorSubject<SelectedCustomer> = new BehaviorSubject(null);
	// The item name to store selectedCustomer in localStorage
	public readonly selectedCustomerItemName = 'selectedCustomer';

	private token: string;
	private userInfo: UserInfo; // = this.token ? this.jwtHelper.decodeToken(this.token) : {};// TODO: add setUserInfoFromToken
	private hasUserSubscription = false;

	// private _a3iApiKey_test: string = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3JfaWQiOjEzNjQsInVzcl9uYW1lIjoieXVtYUBsaW5lYXJiZW5jaC5jb20iLCJ1c3JfZW1haWwiOiJ5dW1hQGxpbmVhcmJlbmNoLmNvbSIsInVzcl9wcm9maWxlIjpudWxsLCJ1c3JfYWRtaW5fZmxhZyI6dHJ1ZSwidXNyX3NhX2ZsYWciOmZhbHNlLCJjdXNfdHlwZSI6ImVuZC11c2VyIiwiY3VzX25hbWVfc2hvcnQiOiJZVU1BOTExIiwiY3VzX25hbWVfbG9uZyI6Ill1bWEgOTExIHRlc3RpbmciLCJjdXNfaWQiOjExOTksInVzcl9zaWdudXBfc3RhdGUiOiJBQ1RJVkUiLCJhZG1pbl9pZHMiOlsxMzY0XSwiYWRtaW5fZW1haWxzIjpbInl1bWFAbGluZWFyYmVuY2guY29tIl0sInBlcm1pc3Npb25zIjp7IkEzSSI6eyJ1c2VyU3Vic2NyaXB0aW9uSWQiOjM2OX19LCJpYXQiOjE2NjkwNzM1MTcsImV4cCI6MTcwMDYwOTUxN30.KNv5cvgxcTXKcuGitdF2pABnUs9kIyQ6R3-nMCxW50I';
	// private _a3iApiKey: string = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3JfaWQiOjEyNzYsInVzcl9uYW1lIjoieXVtYUBsaW5lYXJiZW5jaC5jb20iLCJ1c3JfZW1haWwiOiJ5dW1hQGxpbmVhcmJlbmNoLmNvbSIsInVzcl9wcm9maWxlIjpudWxsLCJ1c3JfYWRtaW5fZmxhZyI6dHJ1ZSwidXNyX3NhX2ZsYWciOmZhbHNlLCJjdXNfdHlwZSI6ImVuZC11c2VyIiwiY3VzX25hbWVfc2hvcnQiOiJZdW1hIDktMS0xIEF1dGhvcml0eSIsImN1c19uYW1lX2xvbmciOm51bGwsImN1c19pZCI6MTEzMSwidXNyX3NpZ251cF9zdGF0ZSI6IkFDVElWRSIsImFkbWluX2lkcyI6WzEyNzZdLCJhZG1pbl9lbWFpbHMiOlsieXVtYUBsaW5lYXJiZW5jaC5jb20iXSwicGVybWlzc2lvbnMiOnsiQTNJIjp7InVzZXJTdWJzY3JpcHRpb25JZCI6Mzg5fX0sImlhdCI6MTY2ODcyNzQ1OCwiZXhwIjoxNzAwMjYzNDU4fQ.0EGq9tV4xRsEZ5rsqfibZpLobPMJ_eYgM_AnKnDRb-E';
	private _a3iApiKey: string;
	private _a3iApiKeyName = 'a3iApiKey';

	constructor(
		private jwtHelper: JwtHelperService,
		private tokenService: AuthTokenService,
		private requestService: CommonRequestService,
	) {
		this.token = localStorage.getItem(this.tokenService.authTokenName);
	}

	async appInit() {
		// set token from local storage
		this.token = localStorage.getItem(this.tokenService.authTokenName);
		// // update userInfo
		// this.setUserInfoFromToken();
		// // Update customerInfo
		// await this.getCustomerInfo(this.userInfo.customerId, true, true);
	}
	getUserInfo(): UserInfo {
		return this.userInfo;
	}
	getCurrentToken() {
		return this.token;
	}
	private setUserInfoFromToken() {
		let info;
		if (!this.userInfo) {
			this.userInfo = {
				customerId: null,
				customerEmail: null,
				customerName: null,
				userId: null,
				userName: null,
				userEmail: null,
				isAdmin: null
			};
		}
		// this.userInfo = {};
		if (!this.token || this.token === 'undefined' || this.jwtHelper.isTokenExpired(this.token)) {
			this.removeToken();
			console.log('No Token Exists!');
			this.userInfo = {
				customerId: null,
				customerEmail: null,
				customerName: null,
				userId: null,
				userName: null,
				userEmail: null,
				isAdmin: null
			};
			return;
		}
		info = this.jwtHelper.decodeToken(this.token);
		this.userInfo.customerId = info.cus_id; // Agency Id
		this.userInfo.customerName = info.cus_name_short; // Agency Name
		this.userInfo.customerEmail = info.cus_email; // Agency Admin's Email
		this.userInfo.userEmail = info.usr_email;
		this.userInfo.userId = info.usr_id;
		this.userInfo.isAdmin = info.usr_admin_flag;
		this.userInfo.parentCustomerId = info.cus_parent_id;
		this.userInfo.isSuperAdmin = info.usr_sa_flag;
	}
	updateUserInfoFromUserSub(userSub: UserSubscription) {
		this.userInfo.subscriptionId = userSub.subId;
		this.userInfo.userSubId = userSub.userSubId;
		this.userSubscription = userSub;
	}

	async setUpdatedToken(token) {
		if (!token) {
			console.log('token updated failed. token: ' + token);
			return;
		}
		this.token = token;
		localStorage.setItem(this.tokenService.authTokenName, token);
		this.setUserInfoFromToken();
		// Update customerInfo
		await this.getCustomerInfo(this.userInfo.customerId, true, true);
	}

	removeToken() {
		// clear token remove user from local storage to log user out
		this.token = null;
		localStorage.removeItem(this.tokenService.authTokenName);
		localStorage.removeItem('userInfo');
	}

	getHasUserSubscription() {
		return this.hasUserSubscription;
	}
	setHasUserSubscription(hasUserSub: boolean) {
		this.hasUserSubscription = hasUserSub;
	}
	isTokenExpired() {
		return this.jwtHelper.isTokenExpired(this.tokenService.getToken());
	}
	isLoggedIn() {
		return !this.isTokenExpired() && this.hasUserSubscription;
	}

	// @updateOrigin: to update the customerInfo object with the service result or keep it as before 
	getCustomerInfo(cusId?: number, updateOrigin?: boolean, getParentInfo?: boolean) {
		return new Promise<CustomerInfo>((resolve, reject) => {
			cusId = cusId || this.userInfo.customerId;
			if (!cusId && cusId !== 0) {
				console.log('Failed to get CustomerInfo; cusId did not exist');
				reject();
			}
			const url = AppSettings.serviceRootUrl + 'admin/customer';
			this.requestService.requestGet(url, {
				params: {
					customerId: cusId
				}
			}, async (rsp) => {
				const data = rsp.data[0];
				const info: CustomerInfo = {
					id: data.cus_id,
					nameLong: data.cus_name_long,
					nameShort: data.cus_name_short,
					type: data.cus_type,
					adminEmails: data.admin_emails,
					level: data.level,
					parentId: data.cus_parent_id,
					children: data.cus_child ? (<any[]>data.cus_child).map((c) => <SubAgency>{
						id: c.id,
						name: c.name,
						adminEmails: c.admin_emails
					}) : [],
					givState: data.cus_state, // data.giv_state,
					cusCounties: data.cus_counties || [],
					cusCentroid: data.cus_centroid,
					neighborCounties: data.ngm_neighbors || [],
					discrepancyId: data.cus_discrp_ag_id,
					bdryCate: data.cus_giv_boundary_cat,
					bdryName: data.cus_giv_boundary_name,
					nguidPattern: {
						layerType: data.cus_nguid_pattern === 2 ? true : false
					}
				};
				info.children.sort((a, b) => {
					if (a.name < b.name) {
						return -1
					} else if (a.name > b.name) {
						return 1;
					} else {
						return 0;
					}
				});
				if (updateOrigin) {
					this.customerInfo = info;
					// Check if selectedCustomer is current customer's child or current customer
					const selectedCustomer = this.selectedCustomer.getValue();
					if (selectedCustomer && selectedCustomer.id) {
						switch (info.type) {
							case 'integrator':
								if (!this.clients || !this.clients.find(c => c.cusId === selectedCustomer.id)) {
									// this.selectedCustomerId.next(null);
									this.selectedCustomer.next(null)
								}
								break;
							default:
								if (selectedCustomer.id !== this.customerInfo.id && !this.customerInfo.children.find(c => c.id === selectedCustomer.id)) {
									// this.selectedCustomerId.next(null);
									this.selectedCustomer.next(null)
								}
						}
					}
				}
				if (getParentInfo && info.parentId) {
					const parentInfo = await this.getCustomerInfo(info.parentId, false);
					info.parentEmails = parentInfo.adminEmails;
					info.parentName = parentInfo.nameShort;
				}
				resolve(info);
			}, err => reject(err));
		});
	}

	// TODO: merge getCustomerIdByTpe & getSelectedCustomerInfo ///////
	// Get customer id by customer type
	// For end-user, customerId is their agency's id; For integrator, it's their client agency's id
	getCustomerIdByType() {
		switch (this.customerInfo.type) {
			case 'integrator':
				const selectedCustomer = this.selectedCustomer.getValue();
				return selectedCustomer ? selectedCustomer.id : null;
			default:
				return this.getUserInfo().customerId
		}
	}
	getSelectedCustomerInfo(info?: 'stateCode') {
		switch (this.customerInfo.type) {
			case 'integrator':
				const selectedCustomer = this.selectedCustomer.getValue();
				if (info === 'stateCode') {
					const client = this.clients.find(c => c.cusId === selectedCustomer.id);
					if (client) {
						return client.givState;
					} else {
						console.log('Can not find client!');
					}
				} else { // Return id as default
					return selectedCustomer ? selectedCustomer.id : null;
				}
				return selectedCustomer ? selectedCustomer.id : null;
			default:
				if (info === 'stateCode') {
					return this.customerInfo.givState;
				} else {
					return this.getUserInfo().customerId
				}
		}
	}

	// Currently using give usbId instead of a3i usbId
	generateApiKey(pw, a3iUsbId) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/apiKey';
			const body: any = {
				email: this.userInfo.userEmail,
				password: pw,
				permissions: JSON.stringify({
					A3I: {
						userSubscriptionId: a3iUsbId
					}
				})
			};
			return this.requestService.requestPost(url, body, rsp => {
				this._a3iApiKey = rsp.data.content;
				localStorage.setItem(this._a3iApiKeyName, this._a3iApiKey);
				resolve(this._a3iApiKey);
			}, err => reject(err), true);
	
		});
	}
	getA3iApiKey() {
		return this._a3iApiKey || localStorage.getItem(this._a3iApiKeyName);
		// if (environment.envName === 'dev') {
		// 	return this._a3iApiKey;
		// } else {
		// 	return this._a3iApiKey_test;
		// }
	}
	removeA3iApiKey() {
		this._a3iApiKey = null;
		localStorage.removeItem(this._a3iApiKeyName);
	}

	getStatesFromNeighborCounties() {
		const states = this.customerInfo.neighborCounties.map(i => i.split(' - ')[0]);
		const distinctStates = states.filter((i, idx) => idx === states.indexOf(i));
		return distinctStates;
	}
	getNeighborCountiesFromCustomer() {
		const counties = this.customerInfo.neighborCounties.map(i => {
			const splits = i.split(' - ');
			if (splits.length > 1) {
				return {
					label: i,
					value: splits[1]
				}
			}
		}); 
		return counties;
	}

}
